// project/src/constants/voiceCloning.ts

/**
 * Cuota de voces clonadas por plan. v1: solo Pro y Ultra pueden clonar.
 * Si el plan no aparece acá, el usuario no puede crear voces (la sección
 * estudio ya bloquea plan free, así que estos valores son para el plan
 * gating del backend defense-in-depth).
 */
export const VOICE_CLONING_QUOTA: Record<string, number> = {
  pro: 5,
  ultra: 20,
};

/**
 * Devuelve la cuota del plan o 0 si el plan no permite clonación.
 */
export function getCloningQuotaForPlan(plan: string | null | undefined): number {
  if (!plan) return 0;
  return VOICE_CLONING_QUOTA[plan.toLowerCase()] ?? 0;
}

/** Duración mínima del sample en segundos. */
export const MIN_SAMPLE_DURATION_SEC = 30;

/** Duración máxima del sample en segundos. */
export const MAX_SAMPLE_DURATION_SEC = 180;

/** Tamaño máximo del sample en bytes (10 MB). */
export const MAX_SAMPLE_SIZE_BYTES = 10 * 1024 * 1024;

/** Extensiones aceptadas para upload de sample. */
export const ALLOWED_SAMPLE_EXTENSIONS = [".mp3", ".m4a", ".wav", ".ogg", ".webm"];
